import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { usePagination } from "../hooks/usePagination";
import UniversalPagination from "../common/UniversalPagination";

import { API_BASE } from '../config/api'

function VideoAsignacion() {

    const [regions, setRegions] = useState([]);
    const [distributors, setDistributors] = useState([]);

    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedDisty, setSelectedDisty] = useState("");

    const [routeData, setRouteData] = useState(null);

    const [loadingRegions, setLoadingRegions] = useState(false);
    const [loadingDistributors, setLoadingDistributors] = useState(false);
    const [loadingRoutes, setLoadingRoutes] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedGradeKey, setSelectedGradeKey] = useState("");

    const [routeDetailData, setRouteDetailData] = useState(null);
    const [loadingRouteDetail, setLoadingRouteDetail] = useState(false);

    const [editRouteData, setEditRouteData] = useState(null);
    const [loadingEditRoute, setLoadingEditRoute] = useState(false);
    const [savingEditRoute, setSavingEditRoute] = useState(false);

    const [editRouteForm, setEditRouteForm] = useState({
        RutaDet_ID: "",
        Disty_ID: "",
        Grado_ID: "",
        Tipo_Ruta: "",
        Video_ID: "",
        Orden_Ruta: "",
        Puntos_Normal: "",
        Puntos_Estreno: "",
        Estreno_Numero: "",
        Fecha_Estreno: "",
        Fecha_Fin_Estreno: "",
        Visible: 1,
    });

    // Modal Principiante
    const [principianteModalData, setPrincipianteModalData] = useState(null);
    const [loadingPrincipianteModal, setLoadingPrincipianteModal] = useState(false);

    const [addPrincipianteForm, setAddPrincipianteForm] = useState({
        Video_ID: "",
        Puntos_Normal: "",
        Orden_Ruta: "",
    });

     // Funcion para agregar video a ruta principiante (modal)
    const loadPrincipianteModalConfig = async () => {
        try {
            if (!selectedDisty) return;

            setLoadingPrincipianteModal(true);
            setPrincipianteModalData(null);

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/principiante-config/${selectedDisty}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible cargar la configuración");
            }

            setPrincipianteModalData(result.data);

            setAddPrincipianteForm({
                Video_ID: "",
                Puntos_Normal: "",
                Orden_Ruta: result?.data?.routeSummary?.nextOrder || 1,
            });
        } catch (error) {
            console.error("Error al cargar modal principiante:", error);
            setErrorMessage(error.message || "Ocurrió un error al abrir el modal");
        } finally {
            setLoadingPrincipianteModal(false);
        }
    };

    // Funcion para guardar video a ruta principiante (modal)
    const savePrincipianteVideo = async () => {
        try {
            if (!selectedDisty) {
                throw new Error("Selecciona un distribuidor");
            }

            if (!addPrincipianteForm.Video_ID) {
                throw new Error("Selecciona un video");
            }

            const gradoPrincipianteId = Number(principianteModalData?.grade?.Grado_ID || 0);

            if (!gradoPrincipianteId) {
                throw new Error("No se pudo identificar el grado Principiante");
            }

            const payload = {
                Disty_ID: Number(selectedDisty),
                Grado_ID: gradoPrincipianteId,
                Video_ID: Number(addPrincipianteForm.Video_ID),
                Tipo_Ruta: "P",
                Orden_Ruta: Number(addPrincipianteForm.Orden_Ruta),
                Puntos_Normal: Number(addPrincipianteForm.Puntos_Normal || 0),
                Activo: 1,
            };

            const response = await fetch(`${API_BASE}/api/admin/videoRouteDisty`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible guardar el video");
            }

            await loadRoutesByDisty(selectedDisty);
        } catch (error) {
            console.error("Error al guardar video principiante:", error);
            setErrorMessage(error.message || "Ocurrió un error al guardar");
        }
    };

    // Modal Intermedio
    const [intermedioModalData, setIntermedioModalData] = useState(null);
    const [loadingIntermedioModal, setLoadingIntermedioModal] = useState(false);
    const [savingIntermedio, setSavingIntermedio] = useState(false);

    const [addIntermedioForm, setAddIntermedioForm] = useState({
        Video_ID: "",
        Orden_Ruta: "",
        Estreno_Numero: "",
        Fecha_Estreno: "",
        Fecha_Fin_Estreno: "",
        Puntos_Estreno: "",
        Puntos_Normal: "",
    });

    // Helpers para la fecha de estreno (Ruta Intermedio)
    const formatDateTimeLocal = (dateValue) => {
        if (!dateValue) return "";

        const date = new Date(dateValue);

        if (Number.isNaN(date.getTime())) return "";

        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const day = `${date.getDate()}`.padStart(2, "0");
        const hours = `${date.getHours()}`.padStart(2, "0");
        const minutes = `${date.getMinutes()}`.padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const formatDateLabel = (dateValue) => {
        if (!dateValue) return "-";

        const date = new Date(dateValue);

        if (Number.isNaN(date.getTime())) return "-";

        return date.toLocaleString("es-MX", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const formatDuration = (seconds) => {
        const totalSeconds = Number(seconds || 0);

        if (!totalSeconds || totalSeconds < 0) return "-";

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        if (hours > 0) {
            return `${hours}h ${minutes}m ${secs}s`;
        }

        if (minutes > 0) {
            return `${minutes}m ${secs}s`;
        }

        return `${secs}s`;
    };

    // Función para cargar configuración y datos necesarios para agregar video a ruta intermedio
    const loadIntermedioModalConfig = async () => {
        try {
            if (!selectedDisty) return;

            setLoadingIntermedioModal(true);
            setIntermedioModalData(null);

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/intermedio-config/${selectedDisty}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible cargar la configuración de intermedio");
            }

            setIntermedioModalData(result?.data || null);

            setAddIntermedioForm({
                Video_ID: "",
                Orden_Ruta: result?.data?.routeSummary?.nextOrder || 1,
                Estreno_Numero: result?.data?.routeSummary?.nextEstrenoNumero || 1,
                Fecha_Estreno: "",
                Fecha_Fin_Estreno: "",
                Puntos_Estreno: "",
                Puntos_Normal: "",
            });
        } catch (error) {
            console.error("Error al cargar modal intermedio:", error);
            setErrorMessage(error.message || "Ocurrió un error al abrir el modal de Intermedio");
        } finally {
            setLoadingIntermedioModal(false);
        }
    };

    // Funcion para guardar video a ruta intermedio (modal)
    const saveIntermedioVideo = async () => {
        try {
            if (!selectedDisty) {
                throw new Error("Selecciona un distribuidor");
            }

            if (!addIntermedioForm.Video_ID) {
                throw new Error("Selecciona un video");
            }

            if (!addIntermedioForm.Orden_Ruta) {
                throw new Error("El orden de ruta es obligatorio");
            }

            if (!addIntermedioForm.Estreno_Numero) {
                throw new Error("El número de estreno es obligatorio");
            }

            if (!addIntermedioForm.Fecha_Estreno) {
                throw new Error("La fecha de estreno es obligatoria");
            }

            if (!addIntermedioForm.Fecha_Fin_Estreno) {
                throw new Error("La fecha fin de estreno es obligatoria");
            }

            if (addIntermedioForm.Puntos_Estreno === "") {
                throw new Error("Los puntos de estreno son obligatorios");
            }

            if (addIntermedioForm.Puntos_Normal === "") {
                throw new Error("Los puntos normales son obligatorios");
            }

            setSavingIntermedio(true);

            const payload = {
                Disty_ID: Number(selectedDisty),
                Video_ID: Number(addIntermedioForm.Video_ID),
                Orden_Ruta: Number(addIntermedioForm.Orden_Ruta),
                Estreno_Numero: Number(addIntermedioForm.Estreno_Numero),
                Fecha_Estreno: addIntermedioForm.Fecha_Estreno,
                Fecha_Fin_Estreno: addIntermedioForm.Fecha_Fin_Estreno,
                Puntos_Estreno: Number(addIntermedioForm.Puntos_Estreno),
                Puntos_Normal: Number(addIntermedioForm.Puntos_Normal),
                Activo: 1,
                Visible: 1,
            };

            const response = await fetch(`${API_BASE}/api/admin/videoRouteDisty/intermedio`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible guardar el video en la ruta intermedio");
            }

            await loadRoutesByDisty(selectedDisty);
            await loadIntermedioModalConfig();

            const modalElement = document.getElementById("addIntermedioVideoModal");
            if (modalElement && window.bootstrap?.Modal) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                modalInstance?.hide();
            }

            setAddIntermedioForm({
                Video_ID: "",
                Orden_Ruta: "",
                Estreno_Numero: "",
                Fecha_Estreno: "",
                Fecha_Fin_Estreno: "",
                Puntos_Estreno: "",
                Puntos_Normal: "",
            });
        } catch (error) {
            console.error("Error al guardar video intermedio:", error);
            setErrorMessage(error.message || "Ocurrió un error al guardar en la ruta Intermedio");
        } finally {
            setSavingIntermedio(false);
        }
    };

    // Efecto para limpir el form de intermedio 
    useEffect(() => {
        const modalElement = document.getElementById("addIntermedioVideoModal");

        if (!modalElement) return;

        const handleHidden = () => {
            setIntermedioModalData(null);
            setAddIntermedioForm({
                Video_ID: "",
                Orden_Ruta: "",
                Estreno_Numero: "",
                Fecha_Estreno: "",
                Fecha_Fin_Estreno: "",
                Puntos_Estreno: "",
                Puntos_Normal: "",
            });
        };

        modalElement.addEventListener("hidden.bs.modal", handleHidden);

        return () => {
            modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        };
    }, []);

    
    // Helpers
    const formatDate = (dateValue) => {
        if (!dateValue) return "-";

        const date = new Date(dateValue);

        if (Number.isNaN(date.getTime())) return "-";

        return date.toLocaleDateString("es-MX", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };

    const getPlanName = (planId) => {
        const plans = {
            1: "🥉 Bronce",
            2: "🥈 Plata",
            3: "🥇 Oro",
        };

        return plans[planId] || "Sin plan";
    };

    const getAvailableGradesByPlan = (planId) => {
        const gradeMap = {
            1: [
                { key: "principiante", label: "Principiante", tipoRuta: "P" },
            ],
            2: [
                { key: "principiante", label: "Principiante", tipoRuta: "P" },
                { key: "intermedio", label: "Intermedio", tipoRuta: "I" },
                { key: "especialista", label: "Especialista", tipoRuta: "E" },
                { key: "lider", label: "Líder", tipoRuta: "L" },
                { key: "pm", label: "Product Manager", tipoRuta: "PM" },
            ],
            3: [
                { key: "principiante", label: "Principiante", tipoRuta: "P" },
                { key: "intermedio", label: "Intermedio", tipoRuta: "I" },
                { key: "especialista", label: "Especialista", tipoRuta: "E" },
                { key: "lider", label: "Líder", tipoRuta: "L" },
                { key: "pm", label: "Product Manager", tipoRuta: "PM" },
            ],
        };

        return gradeMap[Number(planId)] || [];
    };

    const availableGrades = getAvailableGradesByPlan(
        routeData?.distributor?.Disty_Plan_ID
    );

    const currentGradeConfig =
    availableGrades.find((grade) => grade.key === selectedGradeKey) || null;

    
    // Cargar regiones
    const loadRegions = async () => {
        try {
            setLoadingRegions(true);
            setErrorMessage("");

            const response = await fetch(`${API_BASE}/api/admin/videoRouteDisty/regions`, {
                method: "GET",
                credentials: "include",
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible obtener las regiones");
            }

            setRegions(result?.data || []);
        } catch (error) {
            console.error("Error al cargar regiones:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar regiones");
        } finally {
            setLoadingRegions(false);
        }
    };

    
    // Cargar distribuidores por región
    
    const loadDistributorsByRegion = async (regionId) => {
        try {
            setLoadingDistributors(true);
            setErrorMessage("");
            setDistributors([]);
            setSelectedDisty("");
            setRouteData(null);

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/distributors/${regionId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible obtener los distribuidores");
            }

            setDistributors(result?.data || []);
        } catch (error) {
            console.error("Error al cargar distribuidores:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar distribuidores");
        } finally {
            setLoadingDistributors(false);
        }
    };

    
    // Cargar rutas por distribuidor
    const loadRoutesByDisty = async (distyId) => {
        try {
            setLoadingRoutes(true);
            setErrorMessage("");
            setRouteData(null);

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/${distyId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible obtener la configuración de rutas");
            }

            setRouteData(result?.data || null);
        } catch (error) {
            console.error("Error al cargar rutas del distribuidor:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar la configuración");
        } finally {
            setLoadingRoutes(false);
        }
    };

    
    // Effects
    
    useEffect(() => {
        loadRegions();
    }, []);

    useEffect(() => {
        if (selectedRegion) {
            loadDistributorsByRegion(selectedRegion);
            setSelectedGradeKey("");
        } else {
            setDistributors([]);
            setSelectedDisty("");
            setRouteData(null);
            setSelectedGradeKey("");
        }
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedRegion && selectedDisty) {
            loadRoutesByDisty(selectedDisty);
            setSelectedGradeKey("");
        } else {
            setRouteData(null);
            setSelectedGradeKey("");
        }
    }, [selectedDisty, selectedRegion]);

    useEffect(() => {
        if (routeData?.distributor?.Disty_Plan_ID) {
            const grades = getAvailableGradesByPlan(routeData.distributor.Disty_Plan_ID);

            if (grades.length > 0 && !selectedGradeKey) {
                setSelectedGradeKey(grades[0].key);
            }
        }
    }, [routeData]);

    const principianteRoutes = routeData?.routes?.principiante || [];
    const intermedioRoutes = routeData?.routes?.intermedio || [];

    const selectedIntermedioVideo = (intermedioModalData?.availableVideos || []).find(
    (video) => Number(video.Video_ID) === Number(addIntermedioForm.Video_ID)
);

const requiereEvaluacionIntermedio =
    Number(intermedioModalData?.rule?.Requiere_Evaluacion || 0) === 1;

    // Funcion para ver detalle de video en Ruta
    const loadRouteDetail = async (rutaDetId) => {
        try {
            if (!rutaDetId) {
                throw new Error("No se recibió el ID de la ruta");
            }

            setLoadingRouteDetail(true);
            setRouteDetailData(null);
            setErrorMessage("");

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/detail/${rutaDetId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible obtener el detalle de la ruta");
            }

            setRouteDetailData(result?.data || null);
        } catch (error) {
            console.error("Error al cargar detalle de ruta:", error);
            setErrorMessage(error.message || "Ocurrió un error al consultar el detalle");
        } finally {
            setLoadingRouteDetail(false);
        }
    };

    useEffect(() => {
        const modalElement = document.getElementById("viewRouteDetailModal");

        if (!modalElement) return;

        const handleHidden = () => {
            setRouteDetailData(null);
        };

        modalElement.addEventListener("hidden.bs.modal", handleHidden);

        return () => {
            modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        };
    }, []);

    // Funcion para editar video en Ruta
    const loadEditRouteDetail = async (rutaDetId) => {
        try {
            if (!rutaDetId) {
                throw new Error("No se recibió el ID de la ruta");
            }

            setLoadingEditRoute(true);
            setEditRouteData(null);
            setErrorMessage("");

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/detail/${rutaDetId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible obtener el detalle de la ruta");
            }

            const detail = result?.data || null;
            const route = detail?.route || {};
            const video = detail?.video || {};

            if (detail?.route?.Tipo_Ruta === "P") {
                await loadPrincipianteModalConfig();
            }

            if (detail?.route?.Tipo_Ruta === "I") {
                await loadIntermedioModalConfig();
            }

            setEditRouteData(detail);

            setEditRouteForm({
                RutaDet_ID: route?.RutaDet_ID || "",
                Disty_ID: route?.Disty_ID || "",
                Grado_ID: route?.Grado_ID || "",
                Tipo_Ruta: route?.Tipo_Ruta || "",
                Video_ID: route?.Video_ID || "",
                Orden_Ruta: route?.Orden_Ruta || "",
                Puntos_Normal: route?.Puntos_Normal ?? "",
                Puntos_Estreno: route?.Puntos_Estreno ?? "",
                Estreno_Numero: route?.Estreno_Numero ?? "",
                Fecha_Estreno: formatDateTimeLocal(route?.Fecha_Estreno),
                Fecha_Fin_Estreno: formatDateTimeLocal(route?.Fecha_Fin_Estreno),
                Visible: Number(route?.Visible ?? 1),
                CurrentVideoTitle: video?.Video_Titulo || "",
            });
        } catch (error) {
            console.error("Error al cargar edición de ruta:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar la asignación");
        } finally {
            setLoadingEditRoute(false);
        }
    };

    const saveEditRoute = async () => {
        try {
            if (!editRouteForm.RutaDet_ID) {
                throw new Error("No se encontró el identificador de la ruta");
            }

            if (!editRouteForm.Video_ID) {
                throw new Error("Selecciona un video");
            }

            if (!editRouteForm.Orden_Ruta) {
                throw new Error("El orden de ruta es obligatorio");
            }

            const payload = {
                Video_ID: Number(editRouteForm.Video_ID),
                Orden_Ruta: Number(editRouteForm.Orden_Ruta),
                Puntos_Normal: Number(editRouteForm.Puntos_Normal || 0),
                Visible: Number(editRouteForm.Visible ?? 1),
            };

            if (editRouteForm.Tipo_Ruta === "I") {
                if (!editRouteForm.Estreno_Numero) {
                    throw new Error("El número de estreno es obligatorio");
                }

                if (!editRouteForm.Fecha_Estreno) {
                    throw new Error("La fecha de estreno es obligatoria");
                }

                if (!editRouteForm.Fecha_Fin_Estreno) {
                    throw new Error("La fecha fin de estreno es obligatoria");
                }

                payload.Estreno_Numero = Number(editRouteForm.Estreno_Numero);
                payload.Fecha_Estreno = editRouteForm.Fecha_Estreno;
                payload.Fecha_Fin_Estreno = editRouteForm.Fecha_Fin_Estreno;
                payload.Puntos_Estreno = Number(editRouteForm.Puntos_Estreno || 0);
            }

            setSavingEditRoute(true);

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/${editRouteForm.RutaDet_ID}`,
                {
                    method: "PUT",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible actualizar la asignación");
            }

            if (selectedDisty) {
                await loadRoutesByDisty(selectedDisty);
            }

            const modalElement = document.getElementById("editRouteModal");
            if (modalElement && window.bootstrap?.Modal) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                modalInstance?.hide();
            }
        } catch (error) {
            console.error("Error al actualizar ruta:", error);
            setErrorMessage(error.message || "Ocurrió un error al actualizar la asignación");
        } finally {
            setSavingEditRoute(false);
        }
    };

    useEffect(() => {
        const modalElement = document.getElementById("editRouteModal");

        if (!modalElement) return;

        const handleHidden = () => {
            setEditRouteData(null);
            setEditRouteForm({
                RutaDet_ID: "",
                Disty_ID: "",
                Grado_ID: "",
                Tipo_Ruta: "",
                Video_ID: "",
                Orden_Ruta: "",
                Puntos_Normal: "",
                Puntos_Estreno: "",
                Estreno_Numero: "",
                Fecha_Estreno: "",
                Fecha_Fin_Estreno: "",
                Visible: 1,
            });
        };

        modalElement.addEventListener("hidden.bs.modal", handleHidden);

        return () => {
            modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        };
    }, []);

    const getEditVideoOptions = () => {
        if (!editRouteData?.route?.Tipo_Ruta) return [];

        const currentVideo = {
            Video_ID: editRouteData?.video?.Video_ID,
            Video_Titulo: editRouteData?.video?.Video_Titulo,
            Instructor_Nombre: editRouteData?.video?.Instructor_Nombre,
        };

        if (editRouteData.route.Tipo_Ruta === "P") {
            const available = principianteModalData?.availableVideos || [];
            const exists = available.some(
                (video) => Number(video.Video_ID) === Number(currentVideo.Video_ID)
            );

            return exists ? available : [currentVideo, ...available];
        }

        if (editRouteData.route.Tipo_Ruta === "I") {
            const available = intermedioModalData?.availableVideos || [];
            const exists = available.some(
                (video) => Number(video.Video_ID) === Number(currentVideo.Video_ID)
            );

            return exists ? available : [currentVideo, ...available];
        }

        return [currentVideo];
    };

    const editVideoOptions = getEditVideoOptions();

    // Funcion para eliminar video de Ruta
    const deleteRouteVideo = async (rutaDetId) => {
        try {
            const resultConfirm = await Swal.fire({
                title: "¿Eliminar asignación?",
                text: "Esta acción eliminará permanentemente el registro de la ruta y no se podrá recuperar.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
            });

            if (!resultConfirm.isConfirmed) return;

            const response = await fetch(
                `${API_BASE}/api/admin/videoRouteDisty/${rutaDetId}`,
                {
                    method: "DELETE",
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result?.message || "No fue posible eliminar la asignación");
            }

            await Swal.fire({
                title: "Eliminado",
                text: result.message,
                icon: "success",
                confirmButtonText: "Aceptar",
            });

            if (selectedDisty) {
                await loadRoutesByDisty(selectedDisty);
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error.message || "Ocurrió un error al eliminar",
                icon: "error",
                confirmButtonText: "Aceptar",
            });
        }
    };

    // Paginador
    const {
        currentPage: principianteCurrentPage,
        totalPages: principianteTotalPages,
        totalItems: principianteTotalItems,
        paginatedItems: principiantePaginatedItems,
        visiblePages: principianteVisiblePages,
        startItem: principianteStartItem,
        endItem: principianteEndItem,
        goToPage: goToPrincipiantePage,
        goToPreviousPage: goToPrincipiantePreviousPage,
        goToNextPage: goToPrincipianteNextPage,
        resetPagination: resetPrincipiantePagination,
        hasPreviousPage: principianteHasPreviousPage,
        hasNextPage: principianteHasNextPage,
    } = usePagination(principianteRoutes, 8, 5);

    const {
        currentPage: intermedioCurrentPage,
        totalPages: intermedioTotalPages,
        totalItems: intermedioTotalItems,
        paginatedItems: intermedioPaginatedItems,
        visiblePages: intermedioVisiblePages,
        startItem: intermedioStartItem,
        endItem: intermedioEndItem,
        goToPage: goToIntermedioPage,
        goToPreviousPage: goToIntermedioPreviousPage,
        goToNextPage: goToIntermedioNextPage,
        resetPagination: resetIntermedioPagination,
        hasPreviousPage: intermedioHasPreviousPage,
        hasNextPage: intermedioHasNextPage,
    } = usePagination(intermedioRoutes, 5, 5);

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
                
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Asignacion de Sesiones</h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                </div>

                <div class="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="header-title">
                                    <div className="d-flex justify-content-between gap-2 flex-wrap">
                                        <div>
                                            <h4 className="card-title">Ruta del Distribuidor</h4>
                                            <p className="text-primary mb-0">
                                                {!routeData?.distributor && "Selecciona una región y un distribuidor para editar su ruta."}

                                                {routeData?.distributor && !loadingRoutes && (
                                                    <span className="d-flex align-items-center gap-2 flex-wrap">
                                                        <span className="fw-semibold text-primary">
                                                            {routeData.distributor.Disty_Nombre}
                                                        </span>

                                                        <span className="badge bg-secondary-subtle text-dark">
                                                            {getPlanName(routeData.distributor.Disty_Plan_ID)}
                                                        </span>

                                                        {currentGradeConfig && (
                                                            <span className="badge bg-primary-subtle text-primary">
                                                                {currentGradeConfig.label}
                                                            </span>
                                                        )}
                                                    </span>
                                                )}
                                            </p>
                                        </div>

                                        <div className="d-flex justify-content-between gap-2 flex-wrap">
                                            <div className="form-group m-0">
                                                <select
                                                    className="form-select shadow-none"
                                                    value={selectedRegion}
                                                    onChange={(e) => setSelectedRegion(e.target.value)}
                                                    disabled={loadingRegions}
                                                >
                                                    <option value="">Selecciona una Región</option>
                                                    {regions.map((region) => (
                                                        <option key={region.Region_ID} value={region.Region_ID}>
                                                            {region.Region_Nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="form-group m-0">
                                                <select
                                                    className="form-select shadow-none"
                                                    value={selectedDisty}
                                                    onChange={(e) => setSelectedDisty(e.target.value)}
                                                    disabled={!selectedRegion || loadingDistributors}
                                                >
                                                    <option value="">Selecciona un Distribuidor</option>
                                                    {distributors.map((disty) => (
                                                        <option key={disty.Disty_ID} value={disty.Disty_ID}>
                                                            {disty.Disty_Nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="form-group m-0">
                                                <select
                                                    className="form-select shadow-none"
                                                    value={selectedGradeKey}
                                                    onChange={(e) => setSelectedGradeKey(e.target.value)}
                                                    disabled={!routeData?.distributor || loadingRoutes}
                                                >
                                                    <option value="">Selecciona un Grado</option>
                                                    {availableGrades.map((grade) => (
                                                        <option key={grade.key} value={grade.key}>
                                                            {grade.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                {errorMessage && (
                                    <div className="alert alert-danger" role="alert">
                                        {errorMessage}
                                    </div>
                                )}

                                {(loadingDistributors || loadingRoutes) && (
                                    <div className="col-md-12 col-sm-4 mb-4">
                                        <div className="iq-loader-box">
                                            <div className="iq-loader-1"></div>
                                        </div>
                                    </div>
                                )}

                                {/* Debug / impresión de datos */}
                                {/* {routeData && !loadingRoutes && (
                                    <div className="mb-4">
                                        <div className="card border">
                                            <div className="card-header">
                                                <h5 className="mb-0">Datos consultados</h5>
                                            </div>
                                            <div className="card-body">
                                                <pre className="mb-0" style={{ whiteSpace: "pre-wrap" }}>
                                                    {JSON.stringify(routeData, null, 2)}
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                )} */}

                                {/* Info distribuidor */}
                                {/* {routeData?.distributor && !loadingRoutes && (
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <div className="card border">
                                                <div className="card-header">
                                                    <h5 className="mb-0">Distribuidor seleccionado</h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row g-3">
                                                        <div className="col-md-3">
                                                            <strong>ID:</strong> {routeData.distributor.Disty_ID}
                                                        </div>
                                                        <div className="col-md-3">
                                                            <strong>Nombre:</strong> {routeData.distributor.Disty_Nombre}
                                                        </div>
                                                        <div className="col-md-3">
                                                            <strong>Plan:</strong> {routeData.distributor.Disty_Plan_ID}
                                                        </div>
                                                        <div className="col-md-3">
                                                            <strong>Región:</strong> {routeData.distributor.Disty_Region_ID}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )} */}

                                {/* Ruta Principiante */}
                                {!loadingRoutes &&
                                selectedRegion &&
                                selectedDisty &&
                                selectedGradeKey === "principiante" && (
                                    <div className="col-sm-12">
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                <div className="header-title">
                                                    <h4 className="card-title">Ruta Principiante</h4>
                                                </div>

                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#addPrincipianteVideoModal"
                                                    onClick={loadPrincipianteModalConfig}
                                                    disabled={!selectedRegion || !selectedDisty}
                                                >
                                                    <span className="btn-inner me-1">
                                                        <svg
                                                            width="32"
                                                            height="32"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="icon-24"
                                                        >
                                                            <path
                                                                d="M12 4V20M20 12H4"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                    Agregar Video
                                                </button>
                                            </div>

                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th># Orden</th>
                                                                <th>Video</th>
                                                                <th>Puntos</th>
                                                                <th>Estado</th>
                                                                <th>Acción</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {principiantePaginatedItems.length > 0 ? (
                                                                principiantePaginatedItems.map((item) => (
                                                                    <tr key={item.RutaDet_ID}>
                                                                        <td># {item.Orden_Ruta}</td>
                                                                        <td>{item.Video_Titulo}</td>
                                                                        <td>{item.Puntos_Normal}</td>
                                                                        <td>
                                                                            <span
                                                                                className={`badge p-2 ${
                                                                                    Number(item.Activo) === 1
                                                                                        ? "bg-success-subtle text-success"
                                                                                        : "bg-danger-subtle text-danger"
                                                                                }`}
                                                                            >
                                                                                {Number(item.Activo) === 1 ? "Activo" : "Inactivo"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-info-subtle ms-2"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#viewRouteDetailModal"
                                                                                    onClick={() => loadRouteDetail(item.RutaDet_ID)}
                                                                                >
                                                                                    <span className="btn-inner">
                                                                                        <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z" fill="currentColor"></path>
                                                                                        <path d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-warning-subtle ms-2"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#editRouteModal"
                                                                                    onClick={() => loadEditRouteDetail(item.RutaDet_ID)}
                                                                                >
                                                                                    <span className="btn-inner">
                                                                                        <svg
                                                                                            className="icon-32"
                                                                                            width="32"
                                                                                            viewBox="0 0 24 24"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                opacity="0.4"
                                                                                                d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                            <path
                                                                                                d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                            <path
                                                                                                opacity="0.4"
                                                                                                d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-danger-subtle ms-2"
                                                                                    onClick={() => deleteRouteVideo(item.RutaDet_ID)}
                                                                                >
                                                                                    <span className="btn-inner">
                                                                                        <svg
                                                                                            className="icon-32"
                                                                                            width="32"
                                                                                            viewBox="0 0 24 24"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                opacity="0.4"
                                                                                                d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                            <path
                                                                                                d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center text-muted">
                                                                        No hay videos asignados en la ruta principiante
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <UniversalPagination
                                                currentPage={principianteCurrentPage}
                                                totalPages={principianteTotalPages}
                                                totalItems={principianteTotalItems}
                                                startItem={principianteStartItem}
                                                endItem={principianteEndItem}
                                                visiblePages={principianteVisiblePages}
                                                onPageChange={goToPrincipiantePage}
                                                onPrevious={goToPrincipiantePreviousPage}
                                                onNext={goToPrincipianteNextPage}
                                                hasPreviousPage={principianteHasPreviousPage}
                                                hasNextPage={principianteHasNextPage}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Ruta Intermedio */}
                                {!loadingRoutes &&
                                selectedRegion &&
                                selectedDisty &&
                                selectedGradeKey === "intermedio" && (
                                    <div className="col-sm-12 mt-4">
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                <div className="header-title">
                                                    <h4 className="card-title">Ruta Intermedio</h4>
                                                </div>

                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#addIntermedioVideoModal"
                                                    onClick={loadIntermedioModalConfig}
                                                    disabled={!selectedRegion || !selectedDisty}
                                                >
                                                    <span className="btn-inner me-1">
                                                        <svg
                                                            width="32"
                                                            height="32"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="icon-24"
                                                        >
                                                            <path
                                                                d="M12 4V20M20 12H4"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                    Agregar Video
                                                </button>
                                            </div>

                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Video</th>
                                                                <th className="text-center">Estreno</th>
                                                                <th>Pts Estreno</th>
                                                                <th>Pts Normal</th>
                                                                <th>Estado</th>
                                                                <th>Acción</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {intermedioPaginatedItems.length > 0 ? (
                                                                intermedioPaginatedItems.map((item) => (
                                                                    <tr key={item.RutaDet_ID}>
                                                                        <td>#{item.Estreno_Numero || "-"}</td>
                                                                        <td>{item.Video_Titulo}</td>
                                                                        <td>
                                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                                <span className="badge bg-primary-subtle p-2 text-primary">
                                                                                    Inicio: {formatDate(item.Fecha_Estreno)}
                                                                                </span>
                                                                                <span className="badge bg-warning-subtle p-2 text-warning">
                                                                                    Fin: {formatDate(item.Fecha_Fin_Estreno)}
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                        <td>{item.Puntos_Estreno}</td>
                                                                        <td>{item.Puntos_Normal}</td>
                                                                        <td>
                                                                            <span
                                                                                className={`badge p-2 ${
                                                                                    Number(item.Activo) === 1
                                                                                        ? "bg-success-subtle text-success"
                                                                                        : "bg-danger-subtle text-danger"
                                                                                }`}
                                                                            >
                                                                                {Number(item.Activo) === 1 ? "Activo" : "Inactivo"}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-info-subtle ms-2"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#viewRouteDetailModal"
                                                                                    onClick={() => loadRouteDetail(item.RutaDet_ID)}
                                                                                >
                                                                                    <span className="btn-inner">
                                                                                        <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z" fill="currentColor"></path>
                                                                                        <path d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-warning-subtle ms-2"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#editRouteModal"
                                                                                    onClick={() => loadEditRouteDetail(item.RutaDet_ID)}
                                                                                >
                                                                                    <span className="btn-inner">
                                                                                        <svg
                                                                                            className="icon-32"
                                                                                            width="32"
                                                                                            viewBox="0 0 24 24"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                opacity="0.4"
                                                                                                d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                            <path
                                                                                                d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                            <path
                                                                                                opacity="0.4"
                                                                                                d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-icon btn-danger-subtle ms-2"
                                                                                    onClick={() => deleteRouteVideo(item.RutaDet_ID)}
                                                                                >
                                                                                    <span className="btn-inner">
                                                                                        <svg
                                                                                            className="icon-32"
                                                                                            width="32"
                                                                                            viewBox="0 0 24 24"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <path
                                                                                                opacity="0.4"
                                                                                                d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                            <path
                                                                                                d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                                                fill="currentColor"
                                                                                            ></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="7" className="text-center text-muted">
                                                                        No hay videos asignados en la ruta intermedio
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <UniversalPagination
                                                currentPage={intermedioCurrentPage}
                                                totalPages={intermedioTotalPages}
                                                totalItems={intermedioTotalItems}
                                                startItem={intermedioStartItem}
                                                endItem={intermedioEndItem}
                                                visiblePages={intermedioVisiblePages}
                                                onPageChange={goToIntermedioPage}
                                                onPrevious={goToIntermedioPreviousPage}
                                                onNext={goToIntermedioNextPage}
                                                hasPreviousPage={intermedioHasPreviousPage}
                                                hasNextPage={intermedioHasNextPage}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Ruta Especialista */}
                                {!loadingRoutes &&
                                    selectedRegion &&
                                    selectedDisty &&
                                    selectedGradeKey === "especialista" && (
                                        <div className="col-sm-12 mt-4">
                                            <div className="card">
                                                <div className="card-body text-center py-5">
                                                    <h4 className="mb-2">Ruta Especialista</h4>
                                                    <p className="text-muted mb-0">
                                                        Esta ruta se habilitará en el siguiente paso.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {/* Ruta Líder */}
                                {!loadingRoutes &&
                                    selectedRegion &&
                                    selectedDisty &&
                                    selectedGradeKey === "lider" && (
                                        <div className="col-sm-12 mt-4">
                                            <div className="card">
                                                <div className="card-body text-center py-5">
                                                    <h4 className="mb-2">Ruta Líder</h4>
                                                    <p className="text-muted mb-0">
                                                        Esta ruta se habilitará en el siguiente paso.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {/* Ruta Product Manager */}
                                {!loadingRoutes &&
                                    selectedRegion &&
                                    selectedDisty &&
                                    selectedGradeKey === "pm" && (
                                        <div className="col-sm-12 mt-4">
                                            <div className="card">
                                                <div className="card-body text-center py-5">
                                                    <h4 className="mb-2">Ruta Product Manager</h4>
                                                    <p className="text-muted mb-0">
                                                        Esta ruta se habilitará en el siguiente paso.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {/* Mensaje inicial */}
                                {!selectedRegion && !selectedDisty && !loadingRegions && (
                                    <div className="alert alert-info mt-3 mb-0">
                                        Selecciona una región y un distribuidor para consultar la configuración.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Modal Para agregar video a ruta principiante */}
                <div
                    className="modal fade"
                    id="addPrincipianteVideoModal"
                    tabIndex="-1"
                    aria-labelledby="addPrincipianteVideoModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addPrincipianteVideoModalLabel">
                                    Agregar Video a Ruta Principiante
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {loadingPrincipianteModal ? (
                                    <div className="text-center py-4">
                                        <div className="iq-loader-box mx-auto">
                                            <div className="iq-loader-1"></div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {principianteModalData?.distributor && (
                                            <div className="mb-4">
                                                <h6 className="mb-3">Distribuidor</h6>
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <div className="border rounded p-3">
                                                            <strong>Distribuidor:</strong>{" "}
                                                            {principianteModalData.distributor.Disty_Nombre}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="border rounded p-3">
                                                            <strong>Plan:</strong>{" "}
                                                            {principianteModalData.distributor.Plan_Nombre}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {principianteModalData?.rule && (
                                            <div className="mb-4">
                                                <h6 className="mb-3">Regla de nivel</h6>
                                                <div className="row g-3">
                                                    <div className="col-md-4">
                                                        <div className="border rounded p-3">
                                                            <strong>Videos requeridos:</strong>{" "}
                                                            {principianteModalData.rule.Videos_Requeridos}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="border rounded p-3">
                                                            <strong>Asignados:</strong>{" "}
                                                            {principianteModalData.routeSummary.assignedCount}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="border rounded p-3">
                                                            <strong>Disponibles:</strong>{" "}
                                                            {principianteModalData.routeSummary.remainingSlots}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="row g-3">
                                            <div className="col-md-12">
                                                <label className="form-label">Video</label>
                                                <select
                                                    className="form-select"
                                                    value={addPrincipianteForm.Video_ID}
                                                    onChange={(e) =>
                                                        setAddPrincipianteForm((prev) => ({
                                                            ...prev,
                                                            Video_ID: e.target.value,
                                                        }))
                                                    }
                                                >
                                                    <option value="">Selecciona un video</option>
                                                    {(principianteModalData?.availableVideos || []).map((video) => (
                                                        <option key={video.Video_ID} value={video.Video_ID}>
                                                            {video.Video_Titulo}
                                                            {video.Instructor_Nombre
                                                                ? ` - ${video.Instructor_Nombre}`
                                                                : ""}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Orden de Ruta</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    value={addPrincipianteForm.Orden_Ruta}
                                                    onChange={(e) =>
                                                        setAddPrincipianteForm((prev) => ({
                                                            ...prev,
                                                            Orden_Ruta: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <small className="text-muted">
                                                    Posición del video dentro de la ruta.
                                                </small>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Puntos base</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    value={addPrincipianteForm.Puntos_Normal}
                                                    onChange={(e) =>
                                                        setAddPrincipianteForm((prev) => ({
                                                            ...prev,
                                                            Puntos_Normal: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <h6 className="mb-3">Evaluación</h6>

                                            {Number(principianteModalData?.rule?.Requiere_Evaluacion) === 1 ? (
                                                <div className="alert alert-success mb-0">
                                                    Este plan sí requiere evaluación.
                                                    {" "}
                                                    <strong>
                                                        {principianteModalData?.rule?.Evaluaciones_Requeridas || 1}
                                                    </strong>
                                                    {" "}
                                                    evaluación(es) requerida(s).
                                                </div>
                                            ) : (
                                                <div className="alert alert-secondary mb-0">
                                                    Este plan no requiere evaluación. En Bronce no debe mostrarse.
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                >
                                    Cancelar
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={savePrincipianteVideo}
                                >
                                    Guardar Video
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal para agregar video a ruta Intermedio */}
                <div
                    className="modal fade"
                    id="addIntermedioVideoModal"
                    tabIndex="-1"
                    aria-labelledby="addIntermedioVideoModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addIntermedioVideoModalLabel">
                                    Agregar Video a Ruta Intermedio
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {loadingIntermedioModal ? (
                                    <div className="text-center py-4">
                                        <div className="iq-loader-box mx-auto">
                                            <div className="iq-loader-1"></div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {/* Resumen distribuidor */}
                                        {intermedioModalData?.distributor && (
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-4">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Distribuidor</small>
                                                        <strong>{intermedioModalData.distributor.Disty_Nombre}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Plan</small>
                                                        <strong>{intermedioModalData.distributor.Plan_Nombre}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Grado</small>
                                                        <strong>{intermedioModalData?.grade?.Grado_Nombre || "Intermedio"}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Resumen regla */}
                                        {intermedioModalData?.rule && (
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-3">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Videos requeridos</small>
                                                        <strong>{intermedioModalData.rule.Videos_Requeridos}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-md-3">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Asignados</small>
                                                        <strong>{intermedioModalData?.routeSummary?.assignedCount || 0}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-md-3">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Disponibles</small>
                                                        <strong>{intermedioModalData?.routeSummary?.remainingSlots || 0}</strong>
                                                    </div>
                                                </div>

                                                <div className="col-md-3">
                                                    <div className="border rounded p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Maneja estrenos</small>
                                                        <strong>
                                                            {Number(intermedioModalData?.rule?.Maneja_Estrenos || 0) === 1
                                                                ? "Sí"
                                                                : "No"}
                                                        </strong>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Form */}
                                        <div className="row g-3">
                                            <div className="col-md-12">
                                                <label className="form-label">Video disponible</label>
                                                <select
                                                    className="form-select"
                                                    value={addIntermedioForm.Video_ID}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Video_ID: e.target.value,
                                                        }))
                                                    }
                                                >
                                                    <option value="">Selecciona un video</option>
                                                    {(intermedioModalData?.availableVideos || []).map((video) => (
                                                        <option key={video.Video_ID} value={video.Video_ID}>
                                                            {video.Video_Titulo}
                                                            {video.Instructor_Nombre
                                                                ? ` - ${video.Instructor_Nombre}`
                                                                : ""}
                                                        </option>
                                                    ))}
                                                </select>
                                                <small className="text-muted">
                                                    Solo se muestran videos no usados en este distribuidor.
                                                </small>
                                            </div>

                                            <div className="col-md-6 col-lg-3">
                                                <label className="form-label">Orden de Ruta</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    value={addIntermedioForm.Orden_Ruta}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Orden_Ruta: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-3">
                                                <label className="form-label">Estreno Número</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    value={addIntermedioForm.Estreno_Numero}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Estreno_Numero: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-3">
                                                <label className="form-label">Puntos Estreno</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    value={addIntermedioForm.Puntos_Estreno}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Puntos_Estreno: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-3">
                                                <label className="form-label">Puntos Normal</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    value={addIntermedioForm.Puntos_Normal}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Puntos_Normal: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Fecha de Estreno</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    value={addIntermedioForm.Fecha_Estreno}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Fecha_Estreno: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Fecha Fin de Estreno</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    value={addIntermedioForm.Fecha_Fin_Estreno}
                                                    onChange={(e) =>
                                                        setAddIntermedioForm((prev) => ({
                                                            ...prev,
                                                            Fecha_Fin_Estreno: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* Indicadores */}
                                        <div className="mt-4">
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className="alert alert-info mb-0">
                                                        <strong>Regla del nivel:</strong>{" "}
                                                        {requiereEvaluacionIntermedio
                                                            ? "Este nivel requiere evaluación."
                                                            : "Este nivel no requiere evaluación."}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="alert alert-secondary mb-0">
                                                        <strong>Evaluación del video:</strong>{" "}
                                                        {!addIntermedioForm.Video_ID
                                                            ? "Selecciona un video para validar."
                                                            : Number(selectedIntermedioVideo?.Tiene_Evaluacion_Config || 0) === 1
                                                            ? "Este video ya tiene evaluación configurada."
                                                            : "Este video aún no tiene evaluación configurada."}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Preview */}
                                        {/* {(addIntermedioForm.Fecha_Estreno || addIntermedioForm.Fecha_Fin_Estreno) && (
                                            <div className="mt-4">
                                                <div className="card border">
                                                    <div className="card-header">
                                                        <h6 className="mb-0">Vista previa de fechas</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row g-3">
                                                            <div className="col-md-6">
                                                                <small className="text-muted d-block mb-1">
                                                                    Inicio
                                                                </small>
                                                                <strong>{formatDateLabel(addIntermedioForm.Fecha_Estreno)}</strong>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <small className="text-muted d-block mb-1">
                                                                    Fin
                                                                </small>
                                                                <strong>{formatDateLabel(addIntermedioForm.Fecha_Fin_Estreno)}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )} */}

                                        {/* Sin videos */}
                                        {(intermedioModalData?.availableVideos || []).length === 0 && (
                                            <div className="alert alert-warning mt-4 mb-0">
                                                Ya no hay videos disponibles para este distribuidor en la ruta Intermedio.
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                    disabled={savingIntermedio}
                                >
                                    Cancelar
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={saveIntermedioVideo}
                                    disabled={
                                        savingIntermedio ||
                                        loadingIntermedioModal ||
                                        (intermedioModalData?.availableVideos || []).length === 0
                                    }
                                >
                                    {savingIntermedio ? "Guardando..." : "Guardar Video"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Universal para ver el detalle de Video */}

                <div
                    className="modal fade"
                    id="viewRouteDetailModal"
                    tabIndex="-1"
                    aria-labelledby="viewRouteDetailModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="viewRouteDetailModalLabel">
                                    Detalle de Asignación
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {loadingRouteDetail ? (
                                    <div className="text-center py-5">
                                        <div className="iq-loader-box mx-auto">
                                            <div className="iq-loader-1"></div>
                                        </div>
                                    </div>
                                ) : !routeDetailData ? (
                                    <div className="alert alert-warning mb-0">
                                        No se encontró información para mostrar.
                                    </div>
                                ) : (
                                    <>
                                        {/* Datos de la ruta */}
                                        <div className="card border mb-4">
                                            <div className="card-header">
                                                <h6 className="mb-0">Asignación de ruta</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row g-3">
                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Distribuidor</small>
                                                        <strong>{routeDetailData?.route?.Disty_Nombre || "-"}</strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Plan</small>
                                                        <strong>{routeDetailData?.route?.Plan_Nombre || "-"}</strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Grado</small>
                                                        <strong>{routeDetailData?.route?.Grado_Nombre || "-"}</strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Tipo de ruta</small>
                                                        <strong>{routeDetailData?.route?.Tipo_Ruta || "-"}</strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Orden</small>
                                                        <strong>{routeDetailData?.route?.Orden_Ruta || "-"}</strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Puntos base</small>
                                                        <strong>{routeDetailData?.route?.Puntos_Normal ?? "-"}</strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Visible</small>
                                                        <strong>
                                                            {Number(routeDetailData?.route?.Visible || 0) === 1 ? "Sí" : "No"}
                                                        </strong>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <small className="text-muted d-block mb-1">Estado</small>
                                                        <strong>
                                                            {Number(routeDetailData?.route?.Activo || 0) === 1 ? "Activo" : "Inactivo"}
                                                        </strong>
                                                    </div>

                                                    {routeDetailData?.route?.Tipo_Ruta === "I" && (
                                                        <>
                                                            <div className="col-md-3">
                                                                <small className="text-muted d-block mb-1">Estreno número</small>
                                                                <strong>{routeDetailData?.route?.Estreno_Numero || "-"}</strong>
                                                            </div>

                                                            <div className="col-md-3">
                                                                <small className="text-muted d-block mb-1">Puntos estreno</small>
                                                                <strong>{routeDetailData?.route?.Puntos_Estreno ?? "-"}</strong>
                                                            </div>

                                                            <div className="col-md-3">
                                                                <small className="text-muted d-block mb-1">Fecha inicio</small>
                                                                <strong>{formatDateLabel(routeDetailData?.route?.Fecha_Estreno)}</strong>
                                                            </div>

                                                            <div className="col-md-3">
                                                                <small className="text-muted d-block mb-1">Fecha fin</small>
                                                                <strong>{formatDateLabel(routeDetailData?.route?.Fecha_Fin_Estreno)}</strong>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Datos del video */}
                                        <div className="card border mb-4">
                                            <div className="card-header">
                                                <h6 className="mb-0">Información del video</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row g-4 align-items-start">
                                                    <div className="col-md-4">
                                                        {routeDetailData?.video?.Video_Miniatura ? (
                                                            <img
                                                                src={routeDetailData.video.Video_Miniatura}
                                                                alt={routeDetailData?.video?.Video_Titulo || "Miniatura"}
                                                                className="img-fluid rounded border"
                                                            />
                                                        ) : (
                                                            <div className="border rounded p-5 text-center text-muted">
                                                                Sin miniatura
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-md-8">
                                                        <div className="row g-3">
                                                            <div className="col-md-12">
                                                                <small className="text-muted d-block mb-1">Título</small>
                                                                <strong>{routeDetailData?.video?.Video_Titulo || "-"}</strong>
                                                            </div>

                                                            <div className="col-md-12">
                                                                <small className="text-muted d-block mb-1">Descripción</small>
                                                                <div className="border rounded p-3 bg-light">
                                                                    {routeDetailData?.video?.Video_Descripcion || "Sin descripción"}
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <small className="text-muted d-block mb-1">Instructor</small>
                                                                <strong>{routeDetailData?.video?.Instructor_Nombre || "-"}</strong>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <small className="text-muted d-block mb-1">Duración</small>
                                                                <strong>{formatDuration(routeDetailData?.video?.Video_Duracion_Seg)}</strong>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <small className="text-muted d-block mb-1">Tiene evaluación</small>
                                                                <strong>
                                                                    {Number(routeDetailData?.video?.Video_Tiene_Evaluacion || 0) === 1
                                                                        ? "Sí"
                                                                        : "No"}
                                                                </strong>
                                                            </div>

                                                            {routeDetailData?.video?.Video_URL_Vimeo && (
                                                                <div className="col-md-12">
                                                                    <small className="text-muted d-block mb-1">URL Vimeo</small>
                                                                    <div className="border rounded p-3 bg-light">
                                                                        {routeDetailData.video.Video_URL_Vimeo}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Regla */}
                                        <div className="card border mb-4">
                                            <div className="card-header">
                                                <h6 className="mb-0">Regla aplicada</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row g-3">
                                                    <div className="col-md-4">
                                                        <small className="text-muted d-block mb-1">Requiere evaluación</small>
                                                        <strong>
                                                            {Number(routeDetailData?.rule?.Requiere_Evaluacion || 0) === 1
                                                                ? "Sí"
                                                                : "No"}
                                                        </strong>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <small className="text-muted d-block mb-1">Evaluaciones requeridas</small>
                                                        <strong>{routeDetailData?.rule?.Evaluaciones_Requeridas ?? 0}</strong>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <small className="text-muted d-block mb-1">Mostrar puntos</small>
                                                        <strong>
                                                            {Number(routeDetailData?.rule?.Mostrar_Puntos || 0) === 1
                                                                ? "Sí"
                                                                : "No"}
                                                        </strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Evaluación */}
                                        <div className="card border">
                                            <div className="card-header">
                                                <h6 className="mb-0">Evaluación asignada al video</h6>
                                            </div>
                                            <div className="card-body">
                                                {!routeDetailData?.evaluation ? (
                                                    <div className="alert alert-secondary mb-0">
                                                        Para esta asignación no se muestra evaluación.
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="mb-4">
                                                            <div className="row g-3">
                                                                <div className="col-md-6">
                                                                    <small className="text-muted d-block mb-1">Título de evaluación</small>
                                                                    <strong>{routeDetailData?.evaluation?.Evaluacion_Titulo || "-"}</strong>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <small className="text-muted d-block mb-1">Estado</small>
                                                                    <strong>
                                                                        {Number(routeDetailData?.evaluation?.Evaluacion_Activo || 0) === 1
                                                                            ? "Activa"
                                                                            : "Inactiva"}
                                                                    </strong>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <small className="text-muted d-block mb-1">Descripción</small>
                                                                    <div className="border rounded p-3 bg-light">
                                                                        {routeDetailData?.evaluation?.Evaluacion_Descripcion || "Sin descripción"}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {(routeDetailData?.evaluation?.preguntas || []).length > 0 ? (
                                                            <div className="accordion" id="evaluationQuestionsAccordion">
                                                                {routeDetailData.evaluation.preguntas.map((pregunta, index) => (
                                                                    <div className="accordion-item" key={pregunta.Pregunta_ID}>
                                                                        <h2
                                                                            className="accordion-header"
                                                                            id={`headingQuestion${pregunta.Pregunta_ID}`}
                                                                        >
                                                                            <button
                                                                                className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target={`#collapseQuestion${pregunta.Pregunta_ID}`}
                                                                                aria-expanded={index === 0 ? "true" : "false"}
                                                                                aria-controls={`collapseQuestion${pregunta.Pregunta_ID}`}
                                                                            >
                                                                                Pregunta {pregunta.Pregunta_Orden} · {pregunta.Pregunta_Puntos_Estreno} pts
                                                                            </button>
                                                                        </h2>

                                                                        <div
                                                                            id={`collapseQuestion${pregunta.Pregunta_ID}`}
                                                                            className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                                                            aria-labelledby={`headingQuestion${pregunta.Pregunta_ID}`}
                                                                            data-bs-parent="#evaluationQuestionsAccordion"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                <div className="mb-3">
                                                                                    <strong>{pregunta.Pregunta_Texto}</strong>
                                                                                </div>

                                                                                <div className="list-group">
                                                                                    {(pregunta.respuestas || []).map((respuesta) => (
                                                                                        <div
                                                                                            key={respuesta.Respuesta_ID}
                                                                                            className={`list-group-item d-flex justify-content-between align-items-center ${
                                                                                                Number(respuesta.Respuesta_Correcta) === 1
                                                                                                    ? "list-group-item-success"
                                                                                                    : ""
                                                                                            }`}
                                                                                        >
                                                                                            <span>
                                                                                                {respuesta.Respuesta_Orden}. {respuesta.Respuesta_Texto}
                                                                                            </span>

                                                                                            {Number(respuesta.Respuesta_Correcta) === 1 && (
                                                                                                <span className="badge bg-success">
                                                                                                    Correcta
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <div className="alert alert-warning mb-0">
                                                                La evaluación no tiene preguntas registradas.
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Universal para editar el video */}
                <div
    className="modal fade"
    id="editRouteModal"
    tabIndex="-1"
    aria-labelledby="editRouteModalLabel"
    aria-hidden="true"
>
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="editRouteModalLabel">
                    Editar Asignación de Ruta
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>

            <div className="modal-body">
                {loadingEditRoute ? (
                    <div className="text-center py-5">
                        <div className="iq-loader-box mx-auto">
                            <div className="iq-loader-1"></div>
                        </div>
                    </div>
                ) : !editRouteData ? (
                    <div className="alert alert-warning mb-0">
                        No se encontró información para editar.
                    </div>
                ) : (
                    <>
                        <div className="row g-3 mb-4">
                            <div className="col-md-3">
                                <div className="border rounded p-3 h-100">
                                    <small className="text-muted d-block mb-1">Distribuidor</small>
                                    <strong>{editRouteData?.route?.Disty_Nombre || "-"}</strong>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="border rounded p-3 h-100">
                                    <small className="text-muted d-block mb-1">Plan</small>
                                    <strong>{editRouteData?.route?.Plan_Nombre || "-"}</strong>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="border rounded p-3 h-100">
                                    <small className="text-muted d-block mb-1">Grado</small>
                                    <strong>{editRouteData?.route?.Grado_Nombre || "-"}</strong>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="border rounded p-3 h-100">
                                    <small className="text-muted d-block mb-1">Tipo</small>
                                    <strong>{editRouteData?.route?.Tipo_Ruta || "-"}</strong>
                                </div>
                            </div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-12">
                                <label className="form-label">Video asignado</label>
                                <select
                                    className="form-select"
                                    value={editRouteForm.Video_ID}
                                    onChange={(e) =>
                                        setEditRouteForm((prev) => ({
                                            ...prev,
                                            Video_ID: e.target.value,
                                        }))
                                    }
                                >
                                    <option value="">Selecciona un video</option>
                                    {editVideoOptions.map((video) => (
                                        <option key={video.Video_ID} value={video.Video_ID}>
                                            {video.Video_Titulo}
                                            {video.Instructor_Nombre ? ` - ${video.Instructor_Nombre}` : ""}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Orden de Ruta</label>
                                <input
                                    type="number"
                                    min="1"
                                    className="form-control"
                                    value={editRouteForm.Orden_Ruta}
                                    onChange={(e) =>
                                        setEditRouteForm((prev) => ({
                                            ...prev,
                                            Orden_Ruta: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Puntos base</label>
                                <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    value={editRouteForm.Puntos_Normal}
                                    onChange={(e) =>
                                        setEditRouteForm((prev) => ({
                                            ...prev,
                                            Puntos_Normal: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Visible</label>
                                <select
                                    className="form-select"
                                    value={editRouteForm.Visible}
                                    onChange={(e) =>
                                        setEditRouteForm((prev) => ({
                                            ...prev,
                                            Visible: Number(e.target.value),
                                        }))
                                    }
                                >
                                    <option value={1}>Sí</option>
                                    <option value={0}>No</option>
                                </select>
                            </div>
                        </div>

                        {editRouteForm.Tipo_Ruta === "I" && (
                            <div className="mt-4">
                                <div className="card border">
                                    <div className="card-header">
                                        <h6 className="mb-0">Configuración de estreno</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Estreno Número</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    value={editRouteForm.Estreno_Numero}
                                                    onChange={(e) =>
                                                        setEditRouteForm((prev) => ({
                                                            ...prev,
                                                            Estreno_Numero: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Puntos Estreno</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control"
                                                    value={editRouteForm.Puntos_Estreno}
                                                    onChange={(e) =>
                                                        setEditRouteForm((prev) => ({
                                                            ...prev,
                                                            Puntos_Estreno: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Fecha Inicio</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    value={editRouteForm.Fecha_Estreno}
                                                    onChange={(e) =>
                                                        setEditRouteForm((prev) => ({
                                                            ...prev,
                                                            Fecha_Estreno: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Fecha Fin</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    value={editRouteForm.Fecha_Fin_Estreno}
                                                    onChange={(e) =>
                                                        setEditRouteForm((prev) => ({
                                                            ...prev,
                                                            Fecha_Fin_Estreno: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {(editRouteForm.Fecha_Estreno || editRouteForm.Fecha_Fin_Estreno) && (
                                            <div className="mt-4">
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <small className="text-muted d-block mb-1">Vista previa inicio</small>
                                                        <strong>{formatDateLabel(editRouteForm.Fecha_Estreno)}</strong>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <small className="text-muted d-block mb-1">Vista previa fin</small>
                                                        <strong>{formatDateLabel(editRouteForm.Fecha_Fin_Estreno)}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>

            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    disabled={savingEditRoute}
                >
                    Cancelar
                </button>

                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={saveEditRoute}
                    disabled={savingEditRoute || loadingEditRoute || !editRouteData}
                >
                    {savingEditRoute ? "Guardando..." : "Guardar cambios"}
                </button>
            </div>
        </div>
    </div>
</div>

            </div>
        </main>
        </>
    )
}

export default VideoAsignacion